module.exports = __webpack_public_path__ + "img/组 1.d553ec6c.webp";